export default __webpack_public_path__ + "assets/images/stone-149e81fa31cf054c120db8c6df0c93071.png";